import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntWarning } from "src/app/common/dialog";
import {
  HEALTH_RECORD_ATTACHMENT_FORM_KEY_PREFIX,
  MAX_SENDABLE_HEALTH_RECORD_ATTACHMENTS
} from "src/app/support/health-record.constants";
import { sntTranslate } from "src/app/support/translate";

export class HealthRecordAttachmentLimitExceededError extends Error {
  static readonly NAME = "health-record-attachment-limit-exceeded-error";

  constructor() {
    super("Health record attachment selection exceeds the allowed limit");
    this.name = HealthRecordAttachmentLimitExceededError.NAME;
  }
}

export function countSelectedAttachments(
  formData: Record<string, unknown>
): number {
  return Object.entries(formData).filter(
    ([key, value]) =>
      key.startsWith(HEALTH_RECORD_ATTACHMENT_FORM_KEY_PREFIX) && value === true
  ).length;
}

export function getSelectedAttachmentIds(
  formData: Record<string, unknown>
): string[] {
  return Object.entries(formData)
    .filter(
      ([key, value]) =>
        key.startsWith(HEALTH_RECORD_ATTACHMENT_FORM_KEY_PREFIX) && value
    )
    .map(([key]) => key.slice(HEALTH_RECORD_ATTACHMENT_FORM_KEY_PREFIX.length));
}

export function syncAttachmentSelectionOrder(
  selectionOrder: string[],
  attachmentId: string,
  selected: boolean
): void {
  const index: number = selectionOrder.indexOf(attachmentId);

  if (selected) {
    if (index === -1) {
      selectionOrder.push(attachmentId);
    }

    return;
  }

  if (index !== -1) {
    selectionOrder.splice(index, 1);
  }
}

export async function ensureAttachmentSelectionWithinLimit(
  formData: Record<string, unknown>
): Promise<void> {
  const selectedCount: number = countSelectedAttachments(formData);

  if (selectedCount <= MAX_SENDABLE_HEALTH_RECORD_ATTACHMENTS) {
    return;
  }

  await sntWarning(
    sntTranslate(marker("Attenzione")),
    sntTranslate(
      marker(
        "Hai selezionato {{selectedCount}} allegati. Il massimo consentito è {{maxCount}}. Riduci la selezione per procedere."
      ),
      {
        selectedCount,
        maxCount: MAX_SENDABLE_HEALTH_RECORD_ATTACHMENTS
      }
    )
  );

  throw new HealthRecordAttachmentLimitExceededError();
}
